$(document).ready(function () {
    const popupSelector = "#popup145";
    const innerDivSelector = ".inner-div-benefits-bav";
    const successOverlaySelector = "#success-overlay";
    const contactFormSelector = "#contact-formarchitech-bav";

    // Function to show popup
    function showPopup() {
        $(popupSelector).show();
        $(innerDivSelector).css("display", "block");
        $(successOverlaySelector).css("display", "none");
        $(contactFormSelector).css("display", "block");
    }

    // Function to hide popup
    function hidePopup() {
        $(popupSelector).hide();
        $(innerDivSelector).css("display", "none");
        $(successOverlaySelector).css("display", "none");
        $(contactFormSelector).css("display", "none");
    }


    // Show popup when any button with class 'tsc-near-popup-book-visit_1' is clicked
    $(document).on("click", ".tsc-near-popup-book-visit_1", function () {

        const storeLocationKey = event.target.getAttribute("data-store-loctitle");
        const storeName = this.getAttribute('data-storename');

        showPopup();
        gaEvent('book_visit', [window.iplStoreVisitPos, storeName, "", "", "", ""], false);
        window.iplStoreName = storeName;

        // Set the value in the input field
        if (storeLocationKey) {
            document.getElementById('store-location').value = storeLocationKey;
        } else {
            console.error("Store location key not found!");
        }

    });

    // Close popup when the close button or icon is clicked
    $(document).on("click", ".close, .close-icon", function () {
        hidePopup();
    });

    // Close popup when clicking outside of it
    $(window).on("click", function (event) {
        if ($(event.target).is(popupSelector)) {
            hidePopup();
        }
    });
});

let bookavisitclick = '';
let nearestStoreForPopup;
let flag_gtm = true;


$(document).ready(function () {
    const pincodePopupBanner = $('.pincode_popup_banner');




    if (pincodePopupBanner.length) {
        pincodePopupBanner.on('click', function () {
            bookavisitclick = 'enter_pincode';

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    document.querySelector('.locat_button').style.display = 'block';
                },
                (error) => {
                    if (error.code === 1) {
                        document.querySelector('.locat_button').style.display = 'none';
                    } else {
                        document.querySelector('.locat_button').style.display = 'block';
                    }
                }
            );

        });
    }
});




$(document).on('click', '#interior-submit', function (e) {

    const phoneNumber = $('#phone').val().trim() || "";
    const storeLocation = $(document).find('#store-location').val();
    const param1Val = document.querySelector('.inside-luxe-dev').value == 'yes' ? document.querySelector('.store-visit-param1').value : bookavisitclick;

    gaEvent('book_visit_submit', [window.iplStoreVisitPos, "", "", phoneNumber, "", window.iplStoreName], false);
});

// Used for setting data of card in extended popup
function updateStoreCardDetails(store) {
    const popupCard = document.querySelector("#tsc-popup-card");
    const titleElement = popupCard.querySelector(".tsc-near-popup-title");
    const addressElement = popupCard.querySelector(".tsc-near-popup-address");
    const getLocationButton = popupCard.querySelector(".tsc-popup-get-location a");
    const bookVisitButton = popupCard.querySelector(".tsc-near-popup-book-visit_1");
    const getLocat = popupCard.querySelector(".tsc-near-popup-button");


    if (titleElement) {
        titleElement.textContent = store.storeName;
    }

    if (addressElement) {
        addressElement.textContent = store.address;
    }

    if (getLocat) {
        getLocat.setAttribute("data-whatsapp-store-loctitle", store.getStoreLocationKey || "");

    }
    if (getLocationButton) {
        getLocationButton.href = `https://wa.me/919152131284/?text=Share me map location of ${store.getStoreLocationKey}`;

    }

    if (bookVisitButton) {
        bookVisitButton.setAttribute("data-store-loctitle", store.getStoreLocationKey || "");
    }
}

function setPincodeAndShowPopup(pincodeValue) {
    const pincodeInput = document.querySelector('#pincodeInput');
    const popup = document.querySelector('.extended_poup');
    if (pincodeInput && popup) {
        pincodeInput.value = pincodeValue;
        popup.style.display = 'block';
    }
}

// if pincode is present in localstoge add class to open pincode popup
const banner = document.querySelector('.pincode_popup_banner');
if (banner) {
    banner.classList.add('pincode_banner');
}
let isNearerPresent = localStorage.getItem('isNearerStore') ? localStorage.getItem('isNearerStore') : '400102';
const banner1 = document.querySelector('.pincode_popup_banner');

if (isNearerPresent == "false") {
    isNearerPresent = false;
} else if (isNearerPresent == "true") {
    isNearerPresent = true;
}

// function addBanner(){
if (!isNearerPresent) {
    if (banner1) {
        banner1.classList.add('pincode_banner');
    }
}
// }


let locate_global_popup = '';

let locate_global_popup_background = document.querySelector('.store_locatore_popup');
let nearestStores = '';
let flag = false;

// to open close pincode poup
document.addEventListener('DOMContentLoaded', function () {
    const popup_locate_overlay = document.getElementById("poup_overlay");
    const overlay = document.getElementById("poup_overlay");
    const close_btn = document.querySelector('.pincode_close_button');
    const banner = document.querySelector('#pincode_nav_container .pincode_banner');
    const popup = document.querySelector('.pincode_popup');
    const extendedPopup = document.querySelector('.extended_poup');
    const body = document.body;
    const pincodeWrapper = document.querySelector('.pincode_wrapper');
    const carouselItems = document.querySelectorAll('.pincode_caroulse_inner');
    const storedPostcode = localStorage.getItem('popupPincode') ? localStorage.getItem('popupPincode') : '400102';
    const postcodeInput = document.querySelector('#originPincodeInput');
    const pincodeNavContainer = document.querySelector('.pincode_popup_banner');
    const popup_locate_Pincode = localStorage.getItem('popupPincode') ? localStorage.getItem('popupPincode') : '400102';
    const pincodeStripe = document.querySelector('#pincode_nav_container');

    if (pincodeStripe) {
        pincodeStripe.addEventListener('click', () => {
            if ($(window).scrollTop() >= 5 && $(window).scrollTop() <= 56) {
                $('html, body').animate({
                    scrollTop: $('#shopify-section-header').offset().top
                }, 100);
            }
        });
    }

    // If `popupPincode` is present, add the class `pincode_locate`
    if (!popup_locate_Pincode && pincodeNavContainer) {
        pincodeNavContainer.classList.add('pincode_locate');
        const pincodeElement = document.querySelector('.pincode_locate');

        if (pincodeElement) {
            pincodeElement.addEventListener('click', function () {

                if (flag_gtm) {

                }

            });
        }
    }


    let currentIndex = 0;
    let autoScrollInterval;
    function startAutoScroll() {
        autoScrollInterval = setInterval(() => {
            currentIndex = (currentIndex + 1) % carouselItems.length; // Loop to the start if at the end
            const offset = window.innerWidth < 348 ? carouselItems[currentIndex].offsetLeft - 6 : carouselItems[currentIndex].offsetLeft - 9;
            pincodeWrapper.scrollTo({
                left: offset,
                behavior: 'smooth',
            });
        }, 3000);
    }

    startAutoScroll();

    function closePincodePopup() {
        popup.style.display = 'none';
        popup_locate_overlay.style.display = 'none';
        document.body.classList.remove('body_hidden_overflow');
    }

    close_btn.addEventListener('click', () => {
        closePincodePopup();

    });

    // close_btn.addEventListener('click', closePincodePopup);



    popup_locate_overlay.addEventListener('click', () => {
        closePincodePopup();

    });

    banner?.addEventListener('click', function () {
        if (popup && !flag) {
            popup.style.display = 'flex';
            popup_locate_overlay.style.display = "block";
            document.body.classList.add('body_hidden_overflow');
        }
    });

    postcodeInput.addEventListener('click', function () {


    });

    postcodeInput.addEventListener('input', function () {

        const pincode = this.value;
        if (pincode.length === 6) {

            postcodeInput.disabled = true;
            localStorage.setItem('popupPincode', pincode);
            localStorage.setItem('latitude', '');
            localStorage.setItem('longitude', '');
            document.querySelector('#non-servicable').style.display = 'none';
            document.querySelector('#servicable').style.display = 'none';
            const fetchGeocodeData1 = async () => {
                try {
                    const value = await fetchDataOfStores(pincode);
                    if (value === 1) {
                        postcodeInput.disabled = false;
                        localStorage.setItem('locationPermission', '');
                        updateStoreCardDetails(nearestStoreForPopup);
                        extendedPopup.style.display = 'flex';
                        if (!window.location.href.includes('collections')) {
                            setTimeout(function () {
                                handleLocationAndPincode();
                                document.querySelector('.location-permission-granted').classList.add('showlpg');
                            }, 1000);
                        }
                    } else if (value === 2) {
                        postcodeInput.disabled = false;
                        localStorage.setItem('locationPermission', '');
                        const nav_banner_text = document.querySelector('.pincode_banner_innertext');
                        nav_banner_text.innerText = `{{ settings.pincode_popup_serviceable_text }}`
                        document.querySelector('#servicable').style.display = 'flex';
                        document.querySelector('#non-servicable').style.display = 'none';
                        document.querySelector('#cstm-and-non-servicable').style.display = 'none';
                        const removeNearest1 = document.querySelector(".nearest1");
                        const showLpg = document.querySelector('.showlpg');
                        if (showLpg) {
                            showLpg.classList.remove('showlpg');
                        }
                        if (removeNearest1) {
                            removeNearest1.remove();
                        }

                        flag = false;
                    }
                    else {
                        postcodeInput.disabled = false;
                        localStorage.setItem('locationPermission', '');
                        const nav_banner_text = document.querySelector('.pincode_banner_innertext');
                        nav_banner_text.innerText = `{{ settings.pincode_popup_not_serviceable_text }}`
                        document.querySelector('#non-servicable').style.display = 'flex';
                        document.querySelector('#cstm-and-non-servicable').style.display = 'flex';
                        document.querySelector('.store_locatore_popup').style.display = 'none';
                        document.querySelector('#servicable').style.display = 'none';
                        const removeNearest1 = document.querySelector(".nearest1");
                        const showLpg = document.querySelector('.showlpg');
                        if (showLpg) {
                            showLpg.classList.remove('showlpg');
                        }

                        if (removeNearest1) {
                            removeNearest1.remove();
                        }
                        flag = false;
                    }

                } catch (error) {
                    console.error('Error fetching geocode data:', error);
                }
            };

            fetchGeocodeData1();
        } else {
            extendedPopup.style.display = 'none';
            document.querySelector('#non-servicable').style.display = 'none';
            document.querySelector('#servicable').style.display = 'none';
            document.querySelector('#cstm-and-non-servicable').style.display = 'none';
            const nav_banner_text = document.querySelector('.pincode_banner_innertext');
            nav_banner_text.innerText = "{{ settings.pincode_strip }}"
            const removeNearest1 = document.querySelector(".nearest1");

            if (removeNearest1) {
                removeNearest1.remove();
            }
            const showLpg = document.querySelector('.showlpg');
            if (showLpg) {
                showLpg.classList.remove('showlpg');
            }
            flag = false;
        }
    });

});


function removePopupAndShowPincode(pincodeValue) {
    const pincodeInput = document.querySelector('#pincodeInput');
    const popup_pin = document.querySelector('.extended_poup');
    if (pincodeInput && popup_pin) {
        pincodeInput.value = pincodeValue;
        popup_pin.style.display = 'none';
    }
    // const close_btn = document.querySelector('.pincode_close_button');  
    // close_btn.click();
    closePincodePopup();
}

// to close popup when click on header icons
document.addEventListener('DOMContentLoaded', () => {
    const headerIcon = document.querySelector('.additional-icons');
    const mobile_left_icons = document.querySelector('.mobile-left-icons');
    const headerDrawer = document.querySelector('.header-nav');
    const overlay = document.getElementById("poup_overlay");
    const popup = document.querySelector('.pincode_popup');

    function hidePopupOnHeaderIcons() {
        popup.style.display = 'none';
        overlay.style.display = 'none';
    }

    if (headerIcon) {
        headerIcon.addEventListener('click', hidePopupOnHeaderIcons);
    }

    if (mobile_left_icons) {
        mobile_left_icons.addEventListener('click', hidePopupOnHeaderIcons);
    }

    if (headerDrawer) {
        headerDrawer.addEventListener('click', hidePopupOnHeaderIcons);
    }
});

const extendedPopup = document.querySelector('.extended_poup');

var storeLocation = "";
const apiKey = "AIzaSyAaqSOJX04_K5Qhu-t1U2wFr0FHGZKCK6o"; // Replace with your actual API key
let postcode;

$(document).ready(async function () {
    const p_code = localStorage.getItem('popupPincode') ? localStorage.getItem('popupPincode') : '400102'
    if (p_code) {
        const isNearesrStoreExists = await fetchDataOfStores(p_code);
        if (isNearesrStoreExists === 2) {
            document.querySelector('.pincode_banner_innertext').textContent = `{{ settings.pincode_popup_serviceable_text }}`;
            document.getElementById('pincodeInput').value = p_code;
            document.getElementById('servicable').style.display = 'flex';

        } else if (isNearesrStoreExists === 0) {
            document.querySelector('.pincode_banner_innertext').textContent = `{{ settings.pincode_popup_not_serviceable_text }}`;
            document.getElementById('pincodeInput').value = p_code;
            document.getElementById('non-servicable').style.display = 'flex';
        }
    }
});

// add store data dynamically when user edit pincode
async function generateNearestStoresHTMLOnPincodeChange(pincode) {
    let nearerStoreData;
    let nearestDistance;
    if (pincode.length === 6) {
        async function fetchNearestStoreData(pincode) {
            const lat = localStorage.getItem('latitude');
            const long = localStorage.getItem('longitude');
            let apiUrl = '';
            if (lat && long) {
                apiUrl = `https://api.thesleepcompany.in/stores?latitude=${lat}&longitude=${long}&pincode=${pincode}`;
            } else {
                apiUrl = `https://api.thesleepcompany.in/stores?pincode=${pincode}`;
            }
            // const apiUrl = `https://api.thesleepcompany.in/stores?pincode=${pincode}`;
            const apiKey = 'KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q';
            const headers = new Headers({
                'x-api-key': apiKey,
                "Content-Type": "application/json",
            });
            const request = new Request(apiUrl, {
                method: 'GET',
                headers: headers,
            });

            try {
                const res = await fetch(request);
                if (!res.ok) {
                    return 0;
                    // throw new Error(`HTTP error! status: ${res.status}`);
                }

                const data = await res.json();
                const apiData = data.stores;

                if (!apiData || apiData.length === 0) {
                    return 0;
                }

                flag_gtm = false;


                const storeData = apiData
                    .filter(store => store?.distance != null && store?.distance < 25 && store?.distance != 0)
                    .sort((a, b) => a?.distance - b?.distance);

                if (storeData.length === 0) {


                    // if (localStorage.getItem('popupPincode')) {
                    //    const pincodeDiv = document.querySelector('.pincode_locate');
                    //    if (pincodeDiv) {
                    //      pincodeDiv.classList.remove('pincode_locate');
                    //    }
                    //  }

                    localStorage.setItem('isNearerStore', false);
                    // Prepare EDD data
                    const eddData = {
                        dropPincode: pincode,
                        productId: 8070489047269,
                        method: "single",
                        variantId: 43771104198885,
                    };

                    const eddResponse = await fetch("/apps/clickpost-edd-proxy/edd", {
                        method: "POST",
                        headers: {
                            accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify([eddData]),
                    });

                    const eddResult = await eddResponse.json();
                    if (eddResult.res) {
                        return 2;
                    }
                    return 0; // Return the result of EDD check directly
                }

                localStorage.setItem('isNearerStore', true);



                nearestDistance = storeData[0]?.distance;
                if (storeData.length === 0) {
                    return 0;
                }

                nearerStoreData = storeData;
                return 1;
            } catch (error) {
                console.error("Error fetching store data:", error.message);
                return 0;
            }
        }

        const nearestStores = await fetchNearestStoreData(pincode);

        if (nearestStores === 1) {
            localStorage.setItem("popupPincode", pincode)
            const banner_text = document.querySelector('.pincode_banner_innertext .popup_vvvs');
            banner_text.innerHTML = `<span> Nearest Store ${nearestDistance} Km away</span><span> View Store > </span>`;

            let storeHTML = "";

            for (const store of nearerStoreData.slice(0, 3)) {
                storeHTML += `
        <div class="tsc-near-popup-card">
          <p class="tsc-near-popup-title">${store.storeName}</p>
          <p class="tsc-near-popup-address">${store.address}</p>
          <div class="tsc-near-popup-button-container">
            <div class="tsc-near-popup-button tsc-popup-get-location ga-ipl-event-wa-store-visit" data-whatsapp-store-loctitle="${store.getStoreLocationKey}">
              <img loading="lazy" width="24px" height="24px" src="https://cdn.shopify.com/s/files/1/0635/6929/7637/files/image_1690.png?v=1725955116&width=60" alt="whatsapp icon">
              <a href="https://wa.me/919152131284/?text=Share me map location of ${store.getStoreLocationKey}"> Get Location </a>
            </div>
            <button class="tsc-near-popup-book-visit_1" data-store-loctitle="${store.getStoreLocationKey}" data-storename="${store.storeName}" >Book a Visit</button>
          </div>
        </div>`;
            }

            // Remove existing cards
            document.querySelectorAll('.tsc-near-popup-card').forEach(element => element.remove());

            const container = document.createElement('div');
            container.innerHTML = storeHTML;
            // conosle.log("tsctsc")



            const parentElement1 = document.querySelector('.locator_popup_outer');
            const parentElement2 = document.querySelector('.nearest5');

            if (parentElement1) {
                while (container.firstChild) {
                    const node = container.firstChild;
                    parentElement1.appendChild(node);
                    if (parentElement2) {
                        parentElement2.appendChild(node.cloneNode(true));
                    }
                }
            }

            document.querySelectorAll('.non-servicable_1').forEach(element => {
                element.style.display = 'none';
            });
            document.querySelectorAll('.servicable_1').forEach(element => {
                element.style.display = 'none';
            });
            // if (!window.location.href.includes('collections') && isNeareStore === 1) {
            //   setTimeout(function () {
            //    handleLocationAndPincode();
            //   }, 1000);
            // }
            // document.querySelector('.location-permission-granted').classList.add('showlpg');
            const locationElement = document.querySelector('.location-permission-granted');
            if (locationElement) {
                locationElement.classList.add('showlpg');
            }


        } else if (nearestStores === 0) {
            localStorage.setItem("popupPincode", pincode)

            // localStorage.setItem('popupPincode', '');
            const banner_text = document.querySelector('.pincode_banner_innertext .popup_vvvs');
            banner_text.innerText = `{{ settings.pincode_popup_not_serviceable_text }}`;
            document.querySelectorAll('.tsc-near-popup-card').forEach(element => element.remove());
            const showLpg = document.querySelector('.showlpg');
            if (showLpg) {
                showLpg.classList.remove('showlpg');
            }
            // document.querySelectorAll('.non-servicable_1').style.display = 'flex';
            document.querySelectorAll('.non-servicable_1').forEach(element => {
                element.style.display = 'flex';
            });
            document.querySelectorAll('.servicable_1').forEach(element => {
                element.style.display = 'none';
            });


        } else {
            localStorage.setItem("popupPincode", pincode)
            // localStorage.setItem('popupPincode', '');
            const banner_text = document.querySelector('.pincode_banner_innertext .popup_vvvs');
            banner_text.innerText = `{{ settings.pincode_popup_serviceable_text }}`;
            document.querySelectorAll('.tsc-near-popup-card').forEach(element => element.remove());
            const showLpg = document.querySelector('.showlpg');
            if (showLpg) {
                showLpg.classList.remove('showlpg');
            }
            // document.querySelectorAll('.servicable_1').style.display = 'flex';
            document.querySelectorAll('.servicable_1').forEach(element => {
                element.style.display = 'flex';
            });
            document.querySelectorAll('.non-servicable_1').forEach(element => {
                element.style.display = 'none';
            });
        }

        if (document.querySelector('.nearest5')) {
            document.querySelector('.nearest1 .nearerpincodeInput').value = pincode;
        }

        return nearestStores;
    } else {
        const banner_text = document.querySelector('.pincode_banner_innertext .popup_vvvs');
        // banner_text.innerText = `{{ settings.pincode_strip }}`;
        banner_text.innerText = `{{ settings.pincode_popup_not_serviceable_text }}`
        document.querySelectorAll('.tsc-near-popup-card').forEach(element => element.remove());
        return 0
    }
}


// function to add nearest stores in a div   
function generateNearestStoresHTML(nearestStores) {
    let storeHTML = "";
    storeHTML += `<div id="editPincode">

  <div class="popup_head_close">
      <p class="nearest_heading">Nearest stores</p>
      <div class="popup_head_close_btn">
        <img src="//thesleepcompany.in/cdn/shop/t/909/assets/close_icon.svg?v=75510957939235537321744015289" alt="close">
      </div>
</div>
  
   <div class="nearer_pincode_input">
      <div class="nearer_pincode_input_inner">
        <img src="//thesleepcompany.in/cdn/shop/t/909/assets/Vector.png?v=135728000743581146361744015288" alt="Description">
        
        <input
          type="text"
          placeholder="Enter 6-digit Pincode"
          name="pincode" 
          pattern="\d{6}"
          maxlength="6"
          required 
          
          class="nearerpincodeInput"
        >
      </div>
      <button class="nearer_locat_button">Check</button>
    </div>
    <p class="pincode-error-message">Please enter a valid pincode</p>
    </div>
    <div class="servicable_1" >
      <p class="servicable-inner_1">{{ settings.pincode_popup_serviceable_desc }}</p>
      <!-- <p class="servicable-inner_1">Currently, we do not have any stores near you.</p> -->
    </div>
    <div class="non-servicable_1">
      <p class="non-servicable-inner_1">{{ settings.pincode_popup_not_serviceable_desc }}</p>
    </div>
  `


    for (const store of nearestStores.slice(0, 3)) {
        storeHTML += `
      <div class="tsc-near-popup-card">
        <p class="tsc-near-popup-title">${store.storeName}</p>
        <p class="tsc-near-popup-address">${store.address}</p>
        <div class="tsc-near-popup-button-container">
          <div class="tsc-near-popup-button tsc-popup-get-location ga-ipl-event-wa-store-visit" data-whatsapp-store-loctitle="${store.getStoreLocationKey}">
            <img loading="lazy" width="24px" height="24px" src="https://cdn.shopify.com/s/files/1/0635/6929/7637/files/image_1690.png?v=1725955116&width=60" alt="whatsapp icon">
            <a href="https://wa.me/919152131284/?text=Share me map location of ${store.getStoreLocationKey}"> Get Location </a>
          </div>
          <button class="tsc-near-popup-book-visit_1" data-store-loctitle="${store.getStoreLocationKey}" data-storename="${store.storeName}">Book a Visit</button>
        </div>
      </div>`;

    }
    return storeHTML;
}

async function fetchDataOfStores(popupPincode) {
    const lat = localStorage.getItem('latitude');
    const long = localStorage.getItem('longitude');
    let apiUrl = '';
    if (lat && long) {
        apiUrl = `https://api.thesleepcompany.in/stores?latitude=${lat}&longitude=${long}&pincode=${popupPincode}`;
    } else {
        apiUrl = `https://api.thesleepcompany.in/stores?pincode=${popupPincode}`;
    }
    const apiKey = 'KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q';
    const headers = new Headers({
        'x-api-key': apiKey,
        "Content-Type": "application/json",
    });
    const request = new Request(apiUrl, {
        method: 'GET',
        headers: headers,
    });

    try {
        const res = await fetch(request);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }

        const data = await res.json();
        const apiData = data.stores;

        if (!apiData || apiData.length === 0) {
            return 0;
        }

        const storeData = apiData
            .filter(store => store?.distance != null && store?.distance < 25 && store?.distance != 0)
            .sort((a, b) => a?.distance - b?.distance);

        flag_gtm = false;


        if (storeData.length === 0) {

            localStorage.setItem('isNearerStore', false);

            // Prepare EDD data
            const eddData = {
                dropPincode: popupPincode,
                productId: 8070489047269,
                method: "single",
                variantId: 43771104198885,
            };

            const eddResponse = await fetch("/apps/clickpost-edd-proxy/edd", {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify([eddData]),
            });

            const eddResult = await eddResponse.json();
            if (eddResult.res) {
                return 2;
            }
            return 0; // Return the result of EDD check directly
        }

        localStorage.setItem('isNearerStore', true);


        const removeNearest1 = document.querySelector(".nearest1");

        if (removeNearest1) {
            removeNearest1.remove();
        }


        nearestStores = storeData;
        const store = storeData[0];
        nearestStoreForPopup = storeData[0];
        var storeDiv = document.createElement('div');
        storeDiv.classList.add('locator_popup_outer');
        storeDiv.classList.add('nearest1');


        //   let storeHTML = "";
        //   storeHTML += `<p class="nearest_heading">Nearest 3 stores<p>
        //       <div class="nearest_locator_close_button_1">
        //         <img src="{{ 'close_icon.svg' | asset_url }}" alt="close">
        //       </div>
        //       `
        //   for (const store of nearestStores.slice(0, 3)) {
        //     storeHTML += `
        //           <div class="tsc-near-popup-card">
        //             <p class="tsc-near-popup-title">${store.storeName}</p>
        //             <p class="tsc-near-popup-address">${store.address}</p>
        //             <div class="tsc-near-popup-button-container">
        //             <div class="tsc-near-popup-button tsc-popup-get-location">
        //               <img width="24px" height="24px" src="https://cdn.shopify.com/s/files/1/0635/6929/7637/files/image_1690.png?v=1725955116" alt="whatsapp icon">
        //               <a href="https://wa.me/919152131284/?text=Share me map location of ${store.storeName} - ${store.address}"> Get Location </a>
        //             </div>
        //             <button class="tsc-near-popup-book-visit_1">Book a Visit</button>
        //             </div>
        //           </div>`;
        // }
        storeDiv.innerHTML = generateNearestStoresHTML(nearestStores);
        document.querySelector('.store_locatore_popup #nearer-store').appendChild(storeDiv);


        // document.addEventListener("DOMContentLoaded", function () {
        const cross_btns = document.querySelectorAll(".popup_head_close_btn"); // Query all buttons
        const p_overlay = document.querySelector("#store_locatore_popup_overlay");
        const other_overlay = document.querySelectorAll(".theme_locatore_popup_overlay");
        const other_popups = document.querySelectorAll('.store_locatore_popup');


        cross_btns.forEach(function (cross_btn) { // Loop through all the buttons


            cross_btn.addEventListener("click", function () {

                p_overlay.style.display = "none";
                other_overlay.forEach(function (overlay) {
                    overlay.style.display = "none";
                });
                other_popups.forEach(function (o_popup) {
                    o_popup.style.setProperty("display", "none", "important");
                });
                locate_global_popup_background.style.setProperty("display", "none", "important");
                document.body.classList.remove("body_hidden_overflow");
            });
        });
        // });


        setTimeout(() => {
            const nearerPincodeInput = document.querySelector('.nearerpincodeInput');

            if (nearerPincodeInput) {
                nearerPincodeInput.value = popupPincode;
            }
        }, 10);
        const nearer1 = document.querySelector('.nearest1');

        if (window.innerWidth > 768) {

            nearer1.style.display = "block";
        } else {
            nearer1.style.display = "block";
        }
        const banner_text = document.querySelector('.pincode_banner_innertext');
        banner_text.innerHTML = `<span class="popup_vvvs"><span> Nearest Store ${storeData[0].distance} Km away</span><span> View Store > </span></span>`;


        const pincodeDiv = document.querySelector('.pincode_locate');
        if (pincodeDiv) {
            pincodeDiv.classList.remove('pincode_locate');
        }


        flag = true;

        const triggerButton = document.querySelector(".popup_vvvs");

        // const locatorCloseButtons = document.querySelector(".nearest_locator_close_button_1");
        const locator_overlay = document.querySelector("#store_locatore_popup_overlay");
        // locatorCloseButtons.addEventListener("click", function () {
        //   locate_global_popup_background.style.setProperty("display", "none", "important");
        //   document.body.classList.remove("body_hidden_overflow");
        //   locator_overlay.style.display = "none";
        // });

        triggerButton?.addEventListener("click", function () {
            locate_global_popup_background.style.setProperty("display", "block", "important");

            // const close_btn = document.querySelector('.pincode_close_button');  
            // close_btn.click();


            const popup_locate_overlay1 = document.getElementById("poup_overlay");
            const popup1 = document.querySelector('.pincode_popup');

            popup1.style.display = 'none';
            popup_locate_overlay1.style.display = 'none';



            document.body.classList.add("body_hidden_overflow");
            locator_overlay.style.display = "block";
            if (document.querySelector('.nearest5')) {
                document.querySelector('.nearest5').style.display = "none";
            }
            document.querySelector('.nearest1').style.display = "block";

        });
        document.querySelector('.nearest1 .nearer_locat_button').addEventListener('click', function () {
            const pincode_value = document.querySelector('.nearest1 .nearerpincodeInput').value;
            const existing_error = document.querySelector('.nearest1 .pincode-error-message');
            const pincodeInput = document.querySelector('#pincode_no');

            if (pincode_value && pincodeInput) {
                pincodeInput.value = pincode_value;
            }

            // Remove any existing error message
            if (existing_error) {
                existing_error.style.visibility = "hidden"
            }

            // Validate pincode
            if (pincode_value.length !== 6 || !/^\d+$/.test(pincode_value)) {
                existing_error.style.visibility = "visible"
                return;
            }

            localStorage.setItem('popupPincode', pincode_value);
            localStorage.setItem('latitude', '');
            localStorage.setItem('longitude', '');

            async function callGenerateNearestStoresHTMLOnPincodeChange() {
                const isNearerStore = await generateNearestStoresHTMLOnPincodeChange(pincode_value);

                if (!window.location.href.includes('collections') && isNearerStore === 1) {
                    setTimeout(function () {
                        handleLocationAndPincode();
                    }, 1000);
                }
            }
            callGenerateNearestStoresHTMLOnPincodeChange();



        });
        return 1;
    } catch (error) {
        console.error("Error fetching store data:", error.message);
    }
}

async function onClickHandler() {
    // Check if location permission has been granted before
    if (localStorage.getItem('locationPermission') === 'granted') {

        const storedPostcode = localStorage.getItem('popupPincode') ? localStorage.getItem('popupPincode') : '400102';
        const postcodeInput = document.querySelector('#pincodeInput');

        if (storedPostcode && postcodeInput) {
            postcodeInput.value = storedPostcode;
        }
        const storedLng = localStorage.getItem('longitude')
        const storedLat = localStorage.getItem('latitude')
        if (storedLat && storedLng) {

            autofillPincodeInput();

            const nearestStoreStatus = await fetchDataOfStores(storedPostcode || "");
            if (nearestStoreStatus === 2) {
                document.querySelector('#servicable').style.display = 'flex';
                document.querySelector('#non-servicable').style.display = 'none';
                document.querySelector('.pincode_banner_innertext').innerText = `{{ settings.pincode_popup_serviceable_text }}`;
                const showLpg = document.querySelector('.showlpg');
                if (showLpg) {
                    showLpg.classList.remove('showlpg');
                }

            } else if (nearestStoreStatus === 0) {
                document.querySelector('#servicable').style.display = 'none';
                document.querySelector('#non-servicable').style.display = 'flex';
                document.querySelector('.pincode_banner_innertext').innerText = `{{ settings.pincode_popup_not_serviceable_text }}`
                const showLpg = document.querySelector('.showlpg');
                if (showLpg) {
                    showLpg.classList.remove('showlpg');
                }
            } else {
                extendedPopup.style.display = 'flex';
                if (!window.location.href.includes('collections')) {
                    setTimeout(function () {
                        handleLocationAndPincode();
                    }, 1000);
                }
            }
        }

    } else if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition(onSuccess, onError);
    } else {
        // document.getElementById("postcode").innerText = "Geolocation not supported by your browser.";
    }
}

// auto fill still confused pincode 
function autofillPincodeInput() {
    const pincodeInput = document.querySelector('#pincode_no');
    const popup_pincode = localStorage.getItem('popupPincode') ? localStorage.getItem('popupPincode') : '400102'

    if (popup_pincode && pincodeInput) {
        pincodeInput.value = popup_pincode;
    }
}

async function onSuccess(position) {
    let { latitude, longitude } = position.coords;
    localStorage.setItem('locationPermission', 'granted');
    try {
        const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`);
        const data = await response.json();
        if (data.status === "OK") {
            const addressComponents = data.results[0].address_components;
            postcode = addressComponents.find(comp => comp.types.includes("postal_code"))?.long_name || "Not available";
            localStorage.setItem('popupPincode', postcode);
            localStorage.setItem('latitude', latitude);
            localStorage.setItem('longitude', longitude);

            const postcodeInput = document.querySelector('#originPincodeInput');
            if (postcode && postcodeInput) {
                postcodeInput.value = postcode;
            }


            autofillPincodeInput();
            const nearerStoreStatus = await fetchDataOfStores(postcode);
            if (nearerStoreStatus === 2) {
                document.querySelector('#servicable').style.display = 'flex';
                document.querySelector('#non-servicable').style.display = 'none';
                document.querySelector('.pincode_banner_innertext').innerText = `{{ settings.pincode_popup_serviceable_text }}`;
                const showLpg = document.querySelector('.showlpg');
                if (showLpg) {
                    showLpg.classList.remove('showlpg');
                }
            } else if (nearerStoreStatus === 0) {
                document.querySelector('#servicable').style.display = 'none';
                document.querySelector('#non-servicable').style.display = 'flex';
                document.querySelector('.pincode_banner_innertext').innerText = `{{ settings.pincode_popup_not_serviceable_text }}`
                const showLpg = document.querySelector('.showlpg');

                if (showLpg) {
                    showLpg.classList.remove('showlpg');
                }

            } else {
                document.querySelector('#servicable').style.display = 'none';
                document.querySelector('#non-servicable').style.display = 'none';

                if (!window.location.href.includes('collections')) {
                    setTimeout(function () {
                        handleLocationAndPincode();
                    }, 1000);
                }
                updateStoreCardDetails(nearestStoreForPopup);
                extendedPopup.style.display = 'flex';
            }
        } else {
            // document.getElementById("postcode").innerText = "Unable to retrieve location.";
        }
    } catch (error) {
        // document.getElementById("postcode").innerText = "Error retrieving location.";
        console.error("Geolocation fetch error:", error);
    }
}

function onError(error) {
    console.error("Error with geolocation:", error);
    // document.getElementById("postcode").innerText = "Error retrieving geolocation.";
}

$(document).ready(function () {
    $(".locat_button").on("click", onClickHandler); // Replace #locationButton with your actual button ID
});

// browse store script
document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.getElementById("poup_overlay");
    const popup = document.querySelector('.pincode_popup');
    const browseStore = document.getElementById('browse_store');

    browseStore?.addEventListener('click', () => {
        const isMobile = window.innerWidth <= 768;
        let moveToCollection, navContainer;

        if ("{{ template }}" === "index") {
            moveToCollection = document.querySelector(`.index #${isMobile ? 'collection_tab_mobile_view' : 'collection_tab_desktop_view'}`);
            navContainer = document.querySelector('.index .header-wrapper-parent-div');
        } else if ("{{ template }}" === "collection" || "{{ template }}"?.includes("collection")) {
            moveToCollection = document.getElementById('collection_page_products');
            navContainer = document.querySelector('.header-wrapper-parent-div');
        }

        if (moveToCollection && navContainer) {
            const navHeight = navContainer.offsetHeight;
            const targetPosition = moveToCollection.getBoundingClientRect().top + window.scrollY - navHeight;
            popup.style.display = 'none';
            overlay.style.display = 'none';
            document.body.classList.remove('body_hidden_overflow');
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
    });
});

// hide stripe when search is clicked
document.addEventListener('DOMContentLoaded', () => {
    const searchIcon = document.querySelector('.additional-icons .header-search-icon');
    const backIcon = document.querySelector('.search-modal-container .back-arrow-click');
    const toggleElement = document.querySelector('.toggle_pincode_nav');
    const isMobileView = window.innerWidth <= 768;
    if (isMobileView) {

        backIcon.addEventListener('click', function () {
            toggleElement.classList.remove('active');
        });
        searchIcon.addEventListener('click', function () {
            toggleElement.classList.toggle('active');
        });
    }
});

// close popup of nearest 1 and nearby 5 store
document.addEventListener("DOMContentLoaded", function () {
    const overlay = document.querySelector("#store_locatore_popup_overlay");
    overlay.addEventListener("click", function () {
        locate_global_popup_background.style.setProperty("display", "none", "important");
        document.body.classList.remove("body_hidden_overflow");
        overlay.style.display = "none";
    });
});


// script to craete div of nearest five element and apppend it in dom
document.addEventListener("DOMContentLoaded", function () {
    const mobileLeftIcons = document.querySelector(".mobile-left-icons");
    const additionalIcons = document.querySelector(".additional-icons");
    const pincode_overlay = document.getElementById("poup_overlay");
    const pincode_popup = document.querySelector('.pincode_popup');
    const overlay = document.getElementById("store_locatore_popup_overlay");
    const visitStore = document.querySelector("#visit_store");

    visitStore.addEventListener('click', function () {

        var storeDiv = document.createElement('div');
        storeDiv.classList.add('locator_popup_outer');
        storeDiv.classList.add('nearest5');
        storeDiv.innerHTML = generateNearestStoresHTML(nearestStores);

        document.querySelector('.store_locatore_popup #nearer-store').appendChild(storeDiv);

        const cross_btns = document.querySelectorAll(".popup_head_close_btn"); // Query all buttons
        const p_overlay = document.querySelector("#store_locatore_popup_overlay");

        cross_btns.forEach(function (cross_btn) { // Loop through all the buttons

            cross_btn.addEventListener("click", function () {

                p_overlay.style.display = "none";
                locate_global_popup_background.style.setProperty("display", "none", "important");
                document.body.classList.remove("body_hidden_overflow");
            });
        });

        setTimeout(() => {
            const nearerPincodeInputs = document.querySelectorAll('.nearerpincodeInput');
            const pop_pincode = localStorage.getItem('popupPincode') ? localStorage.getItem('popupPincode') : '400102';

            if (nearerPincodeInputs.length > 0) {
                nearerPincodeInputs.forEach(input => {
                    input.value = pop_pincode;
                });
            }
        }, 50);

        // const locator_overlay = document.querySelector("#store_locatore_popup_overlay");     
        const nearer5 = document.querySelector('.nearest5');

        nearer5.style.display = "block";

        document.querySelector('.nearest1').style.display = "none";
        overlay.style.display = "block";
        locate_global_popup = document.querySelectorAll(".locator_popup_outer");
        locate_global_popup_background.style.setProperty("display", "block", "important");
        pincode_overlay.style.display = "none";
        pincode_popup.style.display = "none";

        document.querySelector('.nearest5 .nearer_locat_button').addEventListener('click', function () {
            const pincodeValue = document.querySelector('.nearest5 .nearerpincodeInput').value;
            const existingError = document.querySelector('.nearest5 .pincode-error-message');
            document.querySelector('.nearest1 .nearerpincodeInput').value = pincodeValue;

            const pincodeInput = document.querySelector('#pincode_no');

            if (pincodeValue && pincodeInput) {
                pincodeInput.value = pincodeValue;
            }


            // Remove any existing error message
            if (existingError) {
                existingError.style.visibility = "hidden"
            }

            // Validate pincode
            if (pincodeValue.length !== 6 || !/^\d+$/.test(pincodeValue)) {
                existingError.style.visibility = "visible"
                return;
            }

            localStorage.setItem('popupPincode', pincodeValue);
            localStorage.setItem('latitude', '');
            localStorage.setItem('longitude', '');
            async function callGenerateNearestStoresHTMLOnPincodeChange() {
                const isNearerStore = await generateNearestStoresHTMLOnPincodeChange(pincodeValue);
                if (!window.location.href.includes('collections') && isNearerStore === 1) {
                    setTimeout(function () {
                        handleLocationAndPincode();
                    }, 1000);
                }
            }
            callGenerateNearestStoresHTMLOnPincodeChange();


            // setTimeout(function () {
            //   handleLocationAndPincode();
            // }, 1000);
        });


    });

    function hidePopup() {
        // Set the overlay's display to none
        document.body.classList.remove("body_hidden_overflow")
        overlay.style.display = "none";
        locate_global_popup_background.style.setProperty("display", "none", "important");
    }

    // Add event listeners to both elements
    if (mobileLeftIcons) {
        mobileLeftIcons.addEventListener("click", hidePopup);
    }

    if (additionalIcons) {
        additionalIcons.addEventListener("click", hidePopup);
    }
});